import InviteTag from './InviteTag';

export default InviteTag;
